import {getCookies} from '../../utils/getters/getCookies';
import {initLeadCatcher} from './a.lead-catcher';

export const initCookiePolicy = () => {
	const currentCookies = getCookies();

	if ( currentCookies['cookie_policy'] )
	{
		initLeadCatcher( currentCookies );
	}
	else
	{
		document.body.insertAdjacentHTML( 'beforeend', '<div class="cookie-policy hide">Продолжая использовать <a href="/">www.cds.spb.ru</a>, вы&nbsp;соглашаетесь на&nbsp;использование файлов cookie. Более подробную информацию можно найти в&nbsp;<a href="/content/cookie-policy.pdf" target="_blank">Политике cookie файлов</a>.<button type="button" class="close">Понятно</button></div>' );

		const cookiePolicyElement = document.querySelector( 'div.cookie-policy.hide' );
		const expires = new Date( 3000, 0 );

		setTimeout( () => {
			cookiePolicyElement.classList.remove( 'hide' );
		}, 1000 );

		cookiePolicyElement.querySelector( 'button.close' ).addEventListener( 'click', () => {
			document.cookie = `cookie_policy=cookie_policy; expires=${expires.toGMTString()}; path=/`;
			cookiePolicyElement.remove();
			initLeadCatcher( currentCookies );
		} );
	}
};
